<template>
  <div class="header-tabs">
    <router-link to="/home" class="tab">首页</router-link>
    <router-link to="/about" class="tab">农技讲堂</router-link>
    <router-link to="/contact" class="tab">教学视频</router-link>
  </div>
</template>

<script>
export default {
  name: 'HeaderTabs',
};
</script>

<style scoped>
.header-tabs {
  display: flex;
  justify-content: center;
  background-color: #444;
  padding: 10px;
}

.tab {
  color: white;
  text-decoration: none;
  margin: 0 15px;
  font-size: 16px;
}

.tab:hover {
  text-decoration: underline;
}

.router-link-active {
  font-weight: bold;
  color: #42b983;
}
</style>